import type { ReactNode } from 'react';

import { cx } from '@mage-ui/styled-system/css';
import {
  tooltip,
  tooltipArrow,
  tooltipRoot,
} from '@mage-ui/styled-system/recipes';
import { Tooltip as MantineTooltip } from '@mantine/core';

export type TooltipProps = {
  children?: ReactNode;
  label: ReactNode;
  offset?: number;
  id?: string;
  position?:
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'left'
    | 'left-start'
    | 'left-end';
  inline?: boolean;
  multiline?: boolean;
  disabled?: boolean;
  target?: string;
  classNames?: {
    tooltip?: string;
    arrow?: string;
  };
};

export const Tooltip = ({ children, classNames, ...props }: TooltipProps) => {
  return (
    <MantineTooltip
      classNames={{
        tooltip: cx(tooltip(), tooltipRoot()),
        arrow: tooltipArrow(),
      }}
      {...props}
    >
      {children}
    </MantineTooltip>
  );
};
